import {z}from'zod';const t=z.object({language:z.string(),rating:z.number()});export{t as AttendantSearchLanguageResponseSchema};